module.exports = __webpack_public_path__ + "static/media/BoundWorx_Part_A_SDS.da7db7bc.pdf";